<div class="flex items-center justify-center dialog-header " *ngIf="showHeader">

    Preview Template

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div 
[ngClass]="{'dialog-content': showDilogContentClass}">
    <div class="right-side-box relative">
        <div class="whatsapp-ui-box">
            <div class="dark:dark-overlay light:hidden dark:absolute dark:block"></div>
            <div class="font-bold text-xl text-black"
            style="font-size: 20px;">
                Preview
            </div>

            <div class="preview-box">

                <div
                    *ngIf="templateType === 'IMAGE' || templateType === 'VIDEO' || templateType === 'DOCUMENT' || templateType === 'LOCATION'">
                    <div *ngIf="templateType === 'IMAGE'" class="header_Text">

                        <div *ngIf="templateType === 'IMAGE'" class="header_Text">
                            <ng-container *ngIf="mediaId; else noImage">
                                <img [src]="'https://api.gupshup.io/wa/184ca697-c88c-426f-8b06-b802c7ceaff3/wa/media/' + mediaId + '?download=false'"
                                    alt="media"
                                    style="max-width: 100%; height: 187px; object-fit: fill; width: 100%; border-radius: 5px; margin-bottom: 8px;" />
                            </ng-container>
                            <ng-template #noImage>
                                <div class="flex justify-center h-[91px] items-center bg-gray-100 rounded-md">
                                    <i class="pi pi-image" style="font-size: 50px; "></i>
                                </div>
                            </ng-template>
                        </div>

                    </div>

                    <div *ngIf="templateType === 'VIDEO'" class="header_Text">
                        <ng-container *ngIf="mediaId; else noVideo">
                            <video
                                [src]="'https://api.gupshup.io/wa/184ca697-c88c-426f-8b06-b802c7ceaff3/wa/media/' + mediaId + '?download=false'"
                                controls class="w-full h-[180px] object-cover rounded-md"></video>
                        </ng-container>
                        <ng-template #noVideo>
                            <div class="flex justify-center h-[91px] items-center bg-gray-100 rounded-md">
                                <!-- <img src="assets/img/video.png" alt="media" styleClass="w-[50px] h-[50px] object-contain" /> -->
                                <i class="pi pi-video" style="font-size: 50px; "></i>
                            </div>
                        </ng-template>
                    </div>

                    <div *ngIf="templateType === 'DOCUMENT'" class="header_Text">
                        <ng-container *ngIf="mediaId; else noDocument">
                            <iframe
                                [src]="'https://api.gupshup.io/wa/184ca697-c88c-426f-8b06-b802c7ceaff3/wa/media/' + mediaId + '?download=false' | safeUrl"
                                width="100%" height="200px"></iframe>
                            <!-- <i *ngIf="template.media === 'document'" class="pi pi-file" style="font-size: 70px; 
                            display: flex;
                            align-items: center;
                            margin-top: 10px;
                            justify-content: center;
                            color: red;"></i>
                            <div *ngIf="template.media === 'document'" style="color: red;
                            font-size: 20px;
                            text-align: center;
                            margin-top: 10px;"> Pdf </div> -->
                        </ng-container>
                        <ng-template #noDocument>
                            <div class="flex justify-center h-[91px] items-center bg-gray-100 rounded-md">
                                <!-- <img src="assets/img/document.png" alt="media" styleClass="w-[50px] h-[50px] object-contain" /> -->
                                <i class="pi pi-file" style="font-size: 50px; "></i>

                            </div>
                        </ng-template>
                    </div>
                </div>

                <div *ngIf="header" class="header_Text">
                    {{ header }}
                </div>

                <div class="body_Text" [innerHTML]="renderedData">
                </div>

                <div class="body_Text footer_Text">
                    {{ footer }}
                </div>

                <div>
                    <div class="timeText">
                        {{currentTime}}
                    </div>
                </div>

                <div class="buttons_ui">
                    <div class="text-center border-t border-gray-200 pb-1 action_text pt-1 text-sm"
                        *ngFor="let item of quickReplyButtons.slice(0,2)">
                        <i class="pi pi-reply action_icon"></i> {{item.value}}
                    </div>
                    <div *ngIf="quickReplyButtons.length < 2">
                        <div class="text-center border-t border-gray-200 pb-1 action_text pt-1 text-sm"
                            *ngFor="let item of urlButtons.slice(0,2-quickReplyButtons.length)">
                            <i class="pi pi-external-link action_icon"></i> {{item.title}}
                        </div>
                    </div>

                    <div *ngIf="quickReplyButtons.length < 2 && urlButtons.length < 2">
                        <div class="text-center border-t border-gray-200 pb-1 action_text pt-1 text-sm"
                            *ngFor="let item of callButtons">
                            <i class="pi pi-phone action_icon"></i> {{item.title}}
                        </div>
                    </div>

                    <div class="text-center border-t border-gray-200 pb-1 pt-2 action_text cursor-pointer"
                        (click)="showAllOptions()"
                        *ngIf="quickReplyButtons.length + urlButtons.length + callButtons.length > 2">
                        <i class="pi pi-bars action_text"></i> see all option
                    </div>
                </div>


            </div>
            <div class="absolute bottom-0 left-0 bg-white w-full rounded-b-md pt-3 pb-5 z-10" *ngIf="showAllVariables">
                <div class="text-center pb-2 relative text-black font-semibold">
                    All Options
                    <i class="pi pi-times absolute top-0 right-4 cursor-pointer text-black"
                        (click)="showAllOptions()"></i>
                </div>

                <div class="text-center border-b border-gray-200 pb-1 pt-1 action_text"
                    *ngFor="let item of quickReplyButtons">
                    <i class="pi pi-reply action_icon"></i> {{item.value}}
                </div>
                <div>
                    <div class="text-center border-b border-gray-200 pb-1 pt-1 action_text"
                        *ngFor="let item of urlButtons">
                        <i class="pi pi-external-link action_icon"></i> {{item.title}}
                    </div>
                </div>

                <div class="text-center border-b border-gray-200 pb-1 pt-1 action_text"
                    *ngFor="let item of callButtons">
                    <i class="pi pi-phone action_icon"></i> {{item.title}}
                </div>
            </div>
        </div>
    </div>
</div>